import React from "react";

// Universal renderer for Ida document sections. Used by HQ DocumentView and the client workspace.
export const DocumentSections = ({ sections }) => (
  <div className="space-y-10">
    {(sections || []).map((s, i) => (
      <section key={`${i}-${s.heading}`} data-testid="ida-doc-section">
        <div className="flex items-baseline gap-3">
          <span className="font-display font-bold text-[#E53935] text-[12px] shrink-0">{String(i + 1).padStart(2, "0")}</span>
          <h3 className="font-display font-bold text-[19px] md:text-[21px] tracking-[-0.015em] leading-[1.25]">{s.heading}</h3>
        </div>
        {s.body && <p className="mt-3 text-[15px] leading-[1.8] text-[#3d3d3d]">{s.body}</p>}
        {Array.isArray(s.items) && s.items.length > 0 && (
          <ul className="mt-4 space-y-2">
            {s.items.map((it, j) => (
              <li key={`${j}-${String(it).slice(0, 24)}`} className="flex gap-3 text-[14.5px] leading-[1.65] text-ink">
                <span className="text-[#E53935] shrink-0 mt-[1px]">·</span>{it}
              </li>
            ))}
          </ul>
        )}
        {Array.isArray(s.rows) && s.rows.length > 0 && (
          <div className="mt-4 divide-y divide-[#eee] border-t border-b border-[#eee]">
            {s.rows.map((r, j) => (
              <div key={`${j}-${r.label}`} className="py-2.5 flex items-baseline justify-between gap-6">
                <span className="text-[14px] text-ink">{r.label}</span>
                <span className="text-[13.5px] text-muted-ink text-right">{r.value}</span>
              </div>
            ))}
          </div>
        )}
        {s.note && (
          <p className="mt-4 text-[12.5px] leading-[1.65] text-muted-ink border-l border-[#ddd] pl-4 italic">
            {s.note}
          </p>
        )}
      </section>
    ))}
  </div>
);
